export default "__VITE_ASSET__DxEH$IK7__"